import { CSRF_CUSTOM_HEADER } from "../constants";
import { shortId } from "../utils";
import { TRANSACTION_ID_HEADER } from "./constants";
/**
 * Fetch that passes csrf header
 * to protect against attacks.
 */
// TODO: Rename to nextClientFetch
export const nextApiFetch = async <T>(
  url: string,
  init?: RequestInit,
): Promise<T> => {
  // Create new headers input merging existing headers if provided
  const headers: any = { ...(init?.headers || {}) };

  // Set custom header to break CSRF requests
  headers[CSRF_CUSTOM_HEADER] = 1;

  // Add correlation id to api requests.
  const transactionId = shortId();
  headers[TRANSACTION_ID_HEADER] = transactionId;

  const method = init?.method || "GET";

  let response: Response;

  try {
    response = await fetch(url, { ...init, method, headers });
  } catch (err: any) {
    throw new FetchError(err, transactionId);
  }

  let body: any = await response.text();
  try {
    body = JSON.parse(body);
  } catch (err) {
    // Nothing to do there. response is not json.
  }
  if (!response.ok) {
    throw new FetchErrorWithResponse(
      url,
      body,
      method,
      response.status,
      response.statusText,
      headers,
      response.headers,
      transactionId,
    );
  }

  return body;
};

export interface TransactionError {
  transactionId: string;
}
export class FetchError extends Error implements TransactionError {
  constructor(
    public error: Error,
    public transactionId: string,
  ) {
    super(error.message);
  }
}

export class FetchErrorWithResponse extends Error implements TransactionError {
  constructor(
    public url: string,
    public body: any,
    public method: string,
    public status: number,
    public statusText: string,
    public requestHeaders: any,
    public responseHeaders: any,
    public transactionId: string,
  ) {
    super(`Fetch error: ${method}, ${url}, ${status}`);
  }
}
